import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import { getPatientDetail } from "../../connections/getPatientDetail";
// import { Table } from "antd";
import dayjs from "dayjs";
import { deletePatient } from "../../connections/deletePatient";
import { toast } from "react-toastify";
import { imagesend } from "../imagepath";
import { formatDateTime } from "../../utils/constant/constant";

// const columns = [
//   {
//     title: "Uid",
//     dataIndex: "uid",
//   },
//   {
//     title: "Full Name",
//     dataIndex: "full_name",
//   },
//   {
//     title: "First Name",
//     dataIndex: "first_name",
//   },
//   {
//     title: "Last Name",
//     dataIndex: "last_name",
//   },
//   //
//   {
//     title: "Mobile",
//     dataIndex: "mobile",
//   },
//   {
//     title: "Marital Status",
//     dataIndex: "marital_status",
//   },
//   {
//     title: "Gender",
//     dataIndex: "gender",
//   },
//   {
//     title: "Dob",
//     dataIndex: "dob",
//   },
//   {
//     title: "Pincode",
//     dataIndex: "pincode",
//   },
//   {
//     title: "Address",
//     dataIndex: "address",
//   },
//   {
//     title: "City",
//     dataIndex: "city",
//   },
//   {
//     title: "Active",
//     dataIndex: "active",
//   },
//   {
//     title: "Diet",
//     dataIndex: "diet",
//   },
//   {
//     title: "Age",
//     dataIndex: "age",
//   },
//   {
//     title: "Occupation",
//     dataIndex: "occupation",
//     render: (_, record) => (
//       <Link to={`/admin/occupation/${record?.occupation_id}`}>
//         {record?.occupation}
//       </Link>
//     ),
//   },
//   {
//     title: "Education",
//     dataIndex: "education",
//     render: (_, record) => (
//       <Link to={`/admin/education/${record?.education_id}`}>
//         {record?.education}
//       </Link>
//     ),
//   },
//   {
//     title: "Created At",
//     dataIndex: "created_at",
//     render: (date) => (
//       <>{date}</>
//     ),
//   },
//   {
//     title: "Updated At",
//     dataIndex: "updated_at",
//     render: (date) => (
//       <>{date}</>
//     ),
//   },
// ];

const PatientDetails = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const { data: getPatientDetailData, isLoading } = useQuery({
    queryKey: ["getPatientDetailData", id],
    queryFn: () => getPatientDetail(user?.token, id),
    enabled: !!id,
    // staleTime: Infinity, // Keep the data fresh indefinitely

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  // const patientListData = getPatientDetailData ? [getPatientDetailData] : [];
  const handleDeletePatient = async (e) => {
    e.preventDefault();

    try {
      const data = await deletePatient(user?.token, deleteId);
      if (data.status.status === "SUCCESS") {
        toast.success("Patient Deleted Successfully");
        navigate("/patientslist");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <>
      <Header />
      <Sidebar
        id="menu-item4"
        id1="menu-items4"
        activeClassName="patient-list"
      />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Patient Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Patient Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate("/editpatients", {
                                    state: getPatientDetailData,
                                  });
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setDeleteId(getPatientDetailData?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Uid:</span>
                                  <span className="text">
                                    {getPatientDetailData?.uid || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Full Name:</span>
                                  <span className="text">
                                    {getPatientDetailData?.full_name || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">First Name:</span>
                                  <span className="text">
                                    {/* {getPatientDetailData?.first_name || "N/A"} */}
                                    {getPatientDetailData?.full_name?.split(
                                      " "
                                    )[0] || "N/A"}
                                  </span>
                                </li>
                               
                                    <li className="pb-1">
                                  <span className="title">
                                    {"Husband's or Father's"} Name:
                                  </span>
                                  <span className="text">
                                    {/* {getPatientDetailData?.first_name || "N/A"} */}
                                    {getPatientDetailData?.father_or_husband || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Last Name:</span>
                                  <span className="text">
                                    {getPatientDetailData?.full_name?.split(
                                      " "
                                    )[1] || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Mobile:</span>
                                  <span className="text">
                                    {getPatientDetailData?.mobile || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Marital Status:</span>
                                  <span className="text">
                                    {getPatientDetailData?.marital_status ||
                                      "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Gender:</span>
                                  <span className="text">
                                    {getPatientDetailData?.gender || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Dob:</span>
                                  <span className="text">
                                    {getPatientDetailData?.dob || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Pincode:</span>
                                  <span className="text">
                                    {getPatientDetailData?.pincode || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Address:</span>
                                  <span className="text">
                                    {getPatientDetailData?.address || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">City:</span>
                                  <span className="text">
                                    {getPatientDetailData?.city || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Active:</span>
                                  <span className="text">
                                    {getPatientDetailData?.active
                                      ? "Yes"
                                      : "No" || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Diet:</span>
                                  <span className="text">
                                    {getPatientDetailData?.diet || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Age:</span>
                                  <span className="text">
                                    {getPatientDetailData?.age || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Occupation:</span>
                                  <span className="text">
                                    {getPatientDetailData?.occupation ? (
                                      <Link
                                        to={`/admin/occupation/${getPatientDetailData?.occupation_id}`}
                                      >
                                        {getPatientDetailData?.occupation}
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Education:</span>
                                  <span className="text">
                                    {getPatientDetailData?.education ? (
                                      <Link
                                        to={`/admin/education/${getPatientDetailData?.education_id}`}
                                      >
                                        {getPatientDetailData?.education}
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Created At:</span>
                                  <span className="text">
                                    {getPatientDetailData?.created_at
                                      ? formatDateTime(
                                          getPatientDetailData?.created_at
                                        )
                                      : "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>
                                  <span className="text">
                                    {getPatientDetailData?.updated_at
                                      ? formatDateTime(
                                          getPatientDetailData?.updated_at
                                        )
                                      : "N/A"}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="content-details">
                      //   <div style={{ marginLeft: 20 }} className="row">

                      //     <div className="table-responsive doctor-list">
                      //       <Table
                      //         pagination={false}
                      //         columns={columns}
                      //         dataSource={patientListData}
                      //         rowKey={(record) => record.id}
                      //         scroll={{ x: "max-content" }}
                      //       />
                      //     </div>
                      //   </div>
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={handleDeletePatient}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default PatientDetails;
